export const APP_NAME = 'ButlerIQ';
export const REDIRECT_URL_KEY = 'redirectUrl';
